import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoUserStoriesCard from 'eco-design/sections/eco-userstories-card';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744343669632/1.jpg',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            user: 'https://websiteoss.ecoflow.com/upload/image/1744343671359/head1.jpg',
            userName: t('L_item1_user'),
            desc: t('L_item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744343672241/2.jpg',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            user: 'https://websiteoss.ecoflow.com/upload/image/1744343670862/head2.jpg',
            userName: t('L_item2_user'),
            desc: t('L_item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744343671618/3.jpg',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            user: 'https://websiteoss.ecoflow.com/upload/image/1744343670387/head3.jpg',
            userName: t('L_item3_user'),
            desc: t('L_item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744681356354/4.jpg',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            user: 'https://websiteoss.ecoflow.com/upload/image/1744343837456/head4.jpg',
            userName: t('L_item4_user'),
            desc: t('L_item4_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744681356728/5.jpg',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            user: 'https://websiteoss.ecoflow.com/upload/image/1744343669995/head5.jpg',
            userName: t('L_item5_user'),
            desc: t('L_item5_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744681356545/6.jpg',
            icon: 'https://websiteoss.ecoflow.com/upload/image/1736753462659/stories-icon.svg',
            user: 'https://websiteoss.ecoflow.com/upload/image/1744343669821/head6.jpg',
            userName: t('L_item6_user'),
            desc: t('L_item6_desc'),
        },
    ];
    return (
        <div className={`${styles.comp} GtmModuleData-section`} data-section-id="UserListA" data-section-classname=".eco-section-title">
            <EcoSpace />
            <EcoSectionCommon title={t('L_title')} desc={t('L_desc')} sectionCommonLayout="left" />
            <EcoSpaceSmall />
            <EcoUserStoriesCard cardLayout="img-bottom" imgHeight="16-9" items={itemsA} />
            <EcoSpace />
        </div>
    );
}
